// console.log('entro al js custom', BT)

// $(document).ready(function () {
//   $(document).on('click', '.shopify-product-form .pg__option__value', function () {
//     const $slider = $('.product-single__photos > .slick-slider');
//     const title = $(this).attr('title');
//     if (!title) return;

//     $slider.one('reInit', function () {
//       console.log('entro aca')
//       $slider.slick('slickGoTo', 0, false);
//     });

//     $slider.slick('slickUnfilter');
//     $slider.slick('slickFilter', function () {
//       return $(this).data('variant') === title;
//     });
//   });

//   /** Review slider */
//   const slider = $('.js-reviews-slider');

//   if (slider.hasClass('slick-initialized')) return;

//   slider.slick({
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     arrows: true,
//     dots: false,
//     infinite: false,
//     prevArrow: $('.reviews-prev'),
//     nextArrow: $('.reviews-next'),
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1
//         }
//       }
//     ]
//   });


// });




const $slider = $('.pg__mains--slider');
let firstFilterApplied = false;

function applyInitialFilter() {
  const value = $('.pg__option__value.selected').data('value');
  if (firstFilterApplied || !value || !$slider.hasClass('slick-initialized')) {
    return;
  }
  $slider.slick('slickFilter', function () {
    return $(this).data('variant') === value;
  });
  $slider.slick('slickGoTo', 0);

  firstFilterApplied = true;
}
const slickWatcher = setInterval(function () {
  applyInitialFilter();
  if (firstFilterApplied) {
    clearInterval(slickWatcher);
  }
}, 100);

$(document).on('click', '.pg__option__value', function () {
  const value = $(this).data('value');

  if (!$slider.hasClass('slick-initialized')) return;

  $slider.slick('slickUnfilter');
  $slider.slick('slickFilter', function () {
    return $(this).data('variant') === value;
  });
  $slider.slick('slickGoTo', 0);
});



  


